export * from "./ProductDetailsCtaMobileProductData";
